import React, { ReactNode } from 'react';
import { Typography } from 'tfc-components';

import Container from '../Container';

interface SectionProps extends React.HTMLAttributes<HTMLElement> {
  children: ReactNode;
  className?: string;
}

const Section: React.FC<SectionProps> & { Title: React.FC<TitleProps> } = ({
  children,
  className = '',
  ...props
}) => (
  <section className={`o-section ${className}`} {...props}>
    <Container>
      {children}
    </Container>
  </section>
);

interface TitleProps extends React.HTMLAttributes<HTMLHeadingElement> {
  children: ReactNode;
  className?: string;
  sectionName?: string;
}

const Title: React.FC<TitleProps> = ({
  children, className = '', sectionName = '', ...props
}) => (
  <div className="o-section_titleWrap">
    {sectionName && (
      <div className="o-section_titleSection">
        <Typography.Text fontweight="600" extendClasses="o-section_titleSectionText f-14x18">{sectionName}</Typography.Text>
      </div>
    )}
    <Typography.Heading type="h2" extendClasses={`o-section_title f-32x38 ${className}`} {...props} fontweight="700">
      {children}
    </Typography.Heading>
  </div>
);

Section.Title = Title;

export default Section;
